import { V1_1_API_END_POINT } from 'config';
import { apiAxios, apiAxiosAutoLogin } from '../config/axios';
import { User } from '../model/User';
import { StorageService } from 'service/Storage';

export const UserService = {
  async getOTP({ mobileNumber }) {
    const res = await apiAxios.post('/user/otp', {
      phone_number: String(mobileNumber),
    });
    return res.data;
  },
  async getOTPwithRecaptcha({ mobileNumber, token }) {
    const res = await apiAxios.post(
      `${V1_1_API_END_POINT}/user/otp`,
      {
        phone_number: String(mobileNumber),
      },
      {
        headers: {
          'x-token': token,
          'x-platform': 'web',
        },
      }
    );
    return res.data;
  },
  async login({ mobileNumber, otp }) {
    const res = await apiAxios.post('/user/login', {
      phone_number: String(mobileNumber),
      otp: Number(otp),
    });
    return { ...res.data, user: User.from(res.data.user) };
  },
  async getProfile() {
    const res = await apiAxios.get('/user/profile/me');
    StorageService.setUserId(res.data.user_id);
    return User.from(res.data);
  },
  async getTokenForAutoLogin(rt) {
    const payload = {
      refresh_token: rt,
    };
    const res = await apiAxiosAutoLogin.post(`/user/token/refresh`, payload);

    return res.data;
  },

  async getWID() {
    const res = await apiAxios.get(`/user/wallet`);

    return res.data;
  },
};
